import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74cc22b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header",
  "data-main-header": ""
}
const _hoisted_2 = { class: "header__inner" }
const _hoisted_3 = { class: "left-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header__logo__image" }, null, -1))
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = ["data-item-menu"]
const _hoisted_7 = { class: "center-content" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "right-content" }
const _hoisted_10 = {
  key: 0,
  class: "header__decoins"
}
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_menu_user = _resolveComponent("menu-user")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "header__logo",
          to: { name: 'dashboard' }
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaderNavItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "nav-item",
            key: index
          }, [
            (item.route.target)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "nav-item__link",
                  href: item.route.path,
                  target: item.route.target
                }, [
                  _createElementVNode("h2", null, _toDisplayString(item.title), 1)
                ], 8, _hoisted_5))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "nav-item__link",
                  to: { name: item.route.name, params: item.route.params }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", {
                      "data-item-menu": index,
                      class: _normalizeClass({
                selected: item.route.name === _ctx.$router.currentRoute.value.name
              })
                    }, _toDisplayString(item.title), 11, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.shouldShowSearchInput && !_ctx.configuration.isMaintenanceMode)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "header__search",
              placeholder: "O que você quer aprender?",
              "data-search": "",
              value: _ctx.searchQuery,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.globalSearch($event)))
            }, null, 40, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isDecolaTemplate() && _ctx.hasCompany)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatUserDecoins(_ctx.user.decoins)), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_Notification),
        _createElementVNode("div", {
          class: "header__dropdown-button",
          style: _normalizeStyle({
            headerDropdownIsOpen: 'background-color: var(--primary-color)'
          }),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleHeaderOptionsState()), ["prevent"]))
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(["header__dropdown-image", { open: _ctx.headerDropdownIsOpen }]),
            src: _ctx.userPhoto || '',
            onError: _cache[1] || (_cache[1] = 
              event =>
                (event.target.src = require('../../../assets/static/icons/onerror-user.png'))
            ),
            alt: "Sua foto de perfil."
          }, null, 42, _hoisted_11)
        ], 4),
        (_ctx.headerDropdownIsOpen)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleHeaderOptionsState())),
              class: "header__dropdown-backdrop"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_menu_user)
      ])
    ])
  ]))
}